<template>
  <div class="information-fetching-error">
    <h1 v-if="!onlyTextError" class="error-code">
      {{ code }}
    </h1>
    {{ message }}
    <el-button-group v-if="!onlyTextError">
      <el-button type="primary"
                 icon="el-icon-s-home"
                 @click="jumpHome" />
      <el-button type="primary"
                 icon="el-icon-refresh"
                 @click="refresh" />
    </el-button-group>
    <slot />
  </div>
</template>

<script>
import { result, keys } from 'lodash';
import { tokenKeyword } from '../helpers/tokenStorage';

export default {
  props: {
    errors: {
      type: [Object, Error],
      default() {
        return {};
      }
    },
    onlyTextError: { // for showing only text of error
      type: Boolean,
      default: false
    }
  },
  computed: {
    code() {
      return result(this.errors, 'response.status', 500);
    },
    message() {
      let message;

      switch (this.code) {
        case 401:
          message = 'Access denied or token has been expired';
          break;
        case 403:
          message = 'Access denied';
          break;
        case 404:
          message = 'Page not found';
          break;
        default:
          message = this.$t('An error has occured while receiving information');
          break;
      }

      return message;
    }
  },
  methods: {
    refresh() {
      keys(localStorage).forEach((item) => {
        if (item !== tokenKeyword) {
          localStorage.removeItem(item);
        }
      });

      window.location.reload();
    },
    jumpHome() {
      this.$router.push({ name: this.Breadcrumbs.projects });
    }
  }
};
</script>

<style lang="scss">
.information-fetching-error {
  display: flex;
  flex: 1;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  width: 100%;

  .error-code {
    margin: 0;
    font-size: 70px;
    font-weight: 100;
  }

  .el-button-group {
    margin-top: 30px;
  }
}
</style>
